import { TicketSelectionWarningReport } from "../../../../logic/models/ticketselectionwarning";
import { AddToCartPriceResult } from ".";

export type AddToCartResult = {
    IsSuccess: boolean;
    ErrorMessage?: string;
    RedirectToInvalidOperation?: boolean;
    MustSelectNewTickets?: boolean;
    MustRedirectToCart?: boolean;
    PriceResults?: AddToCartPriceResult[];
    warningsReport?: TicketSelectionWarningReport;
};
